{
  "3507862705384986122": "We are having trouble verifying your account, please attempt to re-verify. If the problem persists please contact us:",
  "1856199920316848480": "CALL AAA",
  "194505828462863481": "CALL",
  "4623814453348075508": "Please enter your details to get started with our 24 hr road service.",
  "9154643805570930321": "Please enter your AAA details to get started with our 24 hr road service.",
  "9084622949113164479": "reCaptcha by Google.",
  "5606023232758328379": " Privacy",
  "8826454553473999816": " and ",
  "2544569632476723854": "Terms",
  "4304930410474432433": "<p>We're sorry. Your login credentials don't match your membership profile. Please try again, input:</p>\n<ul>\n <li><strong>FIRST</strong> and <strong>LAST NAME ONLY</strong> <u>associated with your AAA membership</u>: Try different variations, do not use hyphens or middle name.</li>\n <li><strong>ZIP CODE</strong> <u>associated with your AAA membership</u>: use your home zip code/postal code. If you moved and have not changed your address with AAA, use the home zip code/postal code used when you signed up for AAA.</li>\n</ul>\n",
  "1127413822733185182": "<p>We're sorry. Something went wrong while verifying your information. Please try again.</p>",
  "653180531499256178": "<p>It looks like we are having trouble verifying your information details.</p>",
  "4440524734440153673": "If the problem persists,",
  "638773896288575844": "Try again, or use your",
  "2768499270692105706": "First and Last Name",
  "7775745687103185988": "AAA Membership Number",
  "7621075777303042085": "Vehicle Identification Number (VIN)",
  "376003020172409710": "Vehicle License Plate and State",
  "9143659343338723414": "<p>Sorry, we're having trouble verifying your AAA Membership. Make sure you are entering the numbers<strong> displayed on your card and home postal code</strong>.</p>",
  "4673429546766018466": "<p>It looks like we are having trouble verifying your AAA Membership Number. Please try again using your <strong>primary account holder's</strong> details into the first name, last name, and home postal code.</p>",
  "408351360849277769": "<p>It looks like we are having trouble verifying your name and home postal code. Please try again using your <strong>AAA Membership Number and home postal code.</strong></p>",
  "4077858204299097550": "<p>It looks like we are having trouble verifying your AAA Membership Number. Make sure you are entering the <strong>AAA Membership Number displayed on your card and home postal code</strong>.</p>",
  "173919868162035443": "<p>It looks like we're having trouble verifying your Vehicle License Plate and Vehicle Mileage. Please try again using your <strong>Vehicle Identification Number (VIN)</strong>.</p>",
  "8410601855345717390": "<p>It looks like we're having trouble verifying your Vehicle Identification Number (VIN) and Vehicle Mileage. Please try again or use your <strong>Vehicle License Plate</strong>.</p>",
  "6503781526479593589": "<p>It looks like we're having trouble verifying your Vehicle Identification Number (VIN) and Vehicle Mileage. Please try again using your <strong>Vehicle License Plate</strong>.</p>",
  "3687718752514734766": "<p>It looks like we're having trouble verifying your Vehicle License Plate and Vehicle Mileage. Please try again or use your <strong>Vehicle Identification Number (VIN)</strong>.</p>",
  "8397413982791871108": "Or try using your",
  "8322393042243664713": "Unable to login?",
  "6465999946621561944": "Don't have your AAA Membership Number?",
  "4405754258064036451": "Name and Home Postal Code",
  "5674593252524280885": "Call AAA",
  "1751565470889985786": "Call here",
  "6028371114637047813": "First Name",
  "6134315372404901571": " First Name is required. ",
  "4407559560004943843": "Last Name",
  "1017055857840819009": " Last Name is required. ",
  "7173138156467248419": "Membership Number",
  "3285701240013573656": " Membership number is required. ",
  "2792524269091946065": " Membership number must be exactly 16 characters long. ",
  "7708270344948043036": " {$INTERPOLATION} ",
  "2623524733987339825": " Remember me ",
  "6041429819614882001": " You must confirm you are not a robot. ",
  "6249484391846924804": " Confirm ",
  "4451444712968571415": " Use Member Number To Sign In ",
  "2748277520068025484": " Use Member Name To Sign In ",
  "1450918976331690321": "{$START_TAG_DRR_ICON}{$CLOSE_TAG_DRR_ICON} Sign In With Passkey ",
  "8144045218421106912": " Forgot Member Number ",
  "6049009368199223553": " About Passkeys ",
  "9027103269333492711": " Not a Member? ",
  "6427877909211175463": " By selecting Confirm, you accept the ",
  "2749579379831074767": " Terms and Conditions ",
  "4721007402656921350": " Privacy Policy ",
  "9027333455101357051": "Couldn't sign you in with passkey. Try again or use another sign-in method.",
  "5890833044137447416": "Welcome!",
  "7510956113206631321": "Please enter or confirm your vehicle's odometer below to get started with your roadside request.",
  "8873434125903739325": "Please enter your details below to get started with your roadside request.",
  "4848086305568393449": "Please enter your AAA Member details to get started with your roadside request.",
  "3380552851557735887": "Please select your vehicle:",
  "734934965373819800": "Go back",
  "5060104992873903873": "Adjust your location",
  "5055369762621295136": "Help us find you",
  "6645327200464414799": "Drag the map to your precise breakdown location or enter a full address",
  "5171795527469989462": "Set your location",
  "2399650899606844980": "Drag map to move pin",
  "6702335294193404814": "search for a location",
  "8349266787196318325": "confirm location",
  "2953235471192943631": " Confirm Location ",
  "8520799611540090761": "Breakdown Location",
  "8996348957032272077": "Set Breakdown Location",
  "4021860812366269907": "Location Details",
  "7045123878111147511": "Required",
  "4761046835485571527": " Next {$START_TAG_DRR_ICON}{$CLOSE_TAG_DRR_ICON}",
  "1978572838634849210": "At Home / In Driveway",
  "1527014848829515039": "In a Parking Garage",
  "7572396993828932605": "In a Parking Lot",
  "3257793298409521451": "On the Road / Street (Non-Highway)",
  "6028236001700935513": "On the Interstate / Highway",
  "5114336751058438409": "Highway Exit",
  "8964882360012558063": "Enter My Address",
  "4580988005648117665": "Search",
  "7326852181282879609": "suggested shop",
  "8162787379579842000": "Searching...",
  "1865518523086948674": "Sorry, suggestions could not be loaded.",
  "2504058319323712311": "Use current position",
  "840692109692540367": "Sign In",
  "7190243911747321024": "Review and submit",
  "8275450047090056721": "Service Tracking",
  "2750098008700422494": "We're Sorry!",
  "7860418101283165917": "Closed",
  "2226285948756237505": "until arrival",
  "6252696371173672888": "Battery Quotes",
  "4568701148410647318": "AAA Battery Quotes",
  "6233830031953140003": "Get Quotes",
  "3717501133734628767": "No battery quotes",
  "5447301746786979417": "No quotes available for your vehicle",
  "7819314041543176992": "Close",
  "3746101660448577866": "*Battery replacement may not be available in all areas or at all times.",
  "9132792097614191352": "Your service provider is driving to your location.",
  "1746716113334252780": "Please plan to meet your service provider at your vehicle's breakdown location.",
  "3989945387109482756": "Tow",
  "238497882963423948": "Rest easy during your towing service. We appreciate your patience and thank you for choosing us.",
  "6806508986920369710": "We've arrived.",
  "166272444513464025": "Please meet your service provider at your vehicle's breakdown location.",
  "9081883568571545398": "Your request has been received.",
  "3580891849269089480": "We will notify you once your request has been assigned to a service provider.",
  "8084042636504252965": "Request Received",
  "7575520996332003540": "En Route",
  "7596621968644952499": "Arrived",
  "6170082236603228916": "Request",
  "4556958906261851242": "Please be with the vehicle when assistance arrives.",
  "2526863831408005445": "The AAA member is required to be with the vehicle when assistance arrives.<br> Please be prepared to show Photo ID.",
  "744599921555228591": "On Our Way!",
  "4600565296787515345": "ROADSIDE ASSIST",
  "8586969514214450775": "AAA ASSIST",
  "6490688569532630280": "Send",
  "4426738042466538780": "Thinking",
  "4995265551641962648": "Fuel Charge Information",
  "2742052866893113706": "We'll help get you to the nearest service station. A fuel charge may apply for this service.",
  "2387539242412230109": "We're sorry.",
  "7217500509286769479": " It was not possible to load your service options. Please try again. ",
  "7934833136974560675": "Retry",
  "8725303542875623953": "Issue Selection",
  "5063295649720964221": "How can we help you?",
  "1379487740165792642": "What Happened?",
  "3837070145043256486": "Start Request",
  "7397643214924929036": "This issue type is currently unavailable.",
  "6614098000768940685": "Accident",
  "3714156896650215643": "If this is an emergency, please call 911. If not, an expert technician can help transport your vehicle to the nearest authorized auto repair facility.",
  "4127837180659287294": "Battery Test Or Replace",
  "2686615675222520734": "Battery",
  "7929229449092125122": "Battery Jump Start",
  "1532212788231907236": "We can test your battery and jump-start or replace it with a new one on the spot. Please note that battery testing replacement may not be available in all areas.",
  "1666079073089901973": "We can attempt to jump start your battery or tow you to a repair facility.",
  "3473642902390597644": "Experiencing an electric vehicle battery issue? We'll assess the situation and help get you to a charging station or service provider.",
  "112279859555935914": "Any dashboard lights or charge warning on your EV?",
  "9218270785295228352": "Yes, it shows a low battery warning.",
  "5862864750739934991": "No, but there are system warnings.",
  "4675172324179157330": "No power or response.",
  "9100517096724696709": "Need A Tow",
  "6787270058122459315": "An expert technician can help transport your vehicle to the nearest authorized auto repair facility.",
  "4020440838370105900": "What's happening?",
  "1217079084843137811": "My battery is dead or won't hold a charge",
  "8490558953502047785": "I have a flat tire and no usable spare",
  "8272847685065462015": "My engine overheated or died while driving",
  "4103114379493249182": "My transmission won't shift or go into gear",
  "7764137279783948792": "Something else is wrong",
  "3099078401930296910": "Tell us more to help you better",
  "5531315854465985018": "Flat Tire",
  "4301139003507179843": "Depending on the damage to your tire, we'll either install your usable spare, re-inflate your tire, or tow your vehicle.",
  "938186089755102554": "Don’t have a spare? We'll make sure you and your vehicle get safely to a nearby tire repair or replacement location.",
  "112300762970095499": "Do you have spares for each flat tire?",
  "2807800733729323332": "Yes",
  "3542042671420335679": "No",
  "6491627750429341127": "Car Won't Start",
  "3910361768174107122": "Does your car not start, and are you having trouble identifying the problem? We can help.",
  "3136898952316922211": "Vehicle died while driving",
  "1828310215816344520": "The vehicle does not react when I try to start it - no dashboard activity, no sound.",
  "6509564028145231914": "I hear a clicking noise when I try to start the car.",
  "5576713558385508136": "My car cranks, but does not start when I try to start the car.",
  "1345178385174181530": "Battery issue",
  "5386089199310835439": "What is happening with your key or key fob?",
  "2590844870369718742": "Locked Out",
  "2176659033176029418": "Key",
  "7267370775755984357": "Problems with your key? Whether it's lost, broken, or not working, we’ll help you get back on the road.",
  "1073131304671493897": "Locked out? We'll send someone to help you get back into your vehicle.",
  "4872380697349650717": "I have a high priority situation",
  "2403761436161323684": "An agent may follow-up regarding your situation.",
  "8671183489878457757": "It is locked in the vehicle",
  "8464448176771967804": "It is broken or lost",
  "7629299549022370794": "It won't start the car",
  "4270176564896969733": "It won't unlock the door",
  "5536953270314943801": "A person or a pet is locked in the vehicle",
  "423229861993154980": "My medication is locked in the vehicle",
  "6912267234180689163": "Stuck",
  "395139254693543405": "If your vehicle is stuck, a technician will help get you back on the road.",
  "592942285591466618": "We are sorry to hear your vehicle is stuck.",
  "2391317718429478610": "Will your vehicle require a tow after it has been freed and back on the roadway?",
  "2040699163686699779": "Yes, my vehicle will need to be towed to another location.",
  "8468266698341875566": "No, I don't need a tow",
  "1083892150413432214": "Fuel/EV Charge",
  "8271708390471469792": "Out Of Fuel",
  "4347353823087945408": "Out Of Charge",
  "5994746836305612236": "Need a charge or have you run out of fuel? We'll help to get you to the nearest service station. Diesel fuel delivery and charging capabilities available in some locations.",
  "284255185161526674": "Have you run out of battery power? Our team can provide a charge or tow you to the nearest charging station, depending on your vehicle and local service capabilities.",
  "208371421297503600": "Out of gas? We'll deliver fuel or help tow your vehicle to the nearest service station to get you back on the road.",
  "6725665300768973808": "Out of diesel? We'll deliver fuel or tow your vehicle to the nearest service station. Diesel delivery may be limited in some areas.",
  "1131278238586395824": "Please select the fuel type for your vehicle.",
  "2274094072954341769": "Additional fees may apply depending on membership level.",
  "6639719078865772828": "Gasoline",
  "5294828297924157817": "Diesel Fuel",
  "7683384147050467124": "Electric Vehicle",
  "3716416002572111809": "Hydrogen/Alternate",
  "5726454104363206493": "Alert",
  "381426186146688465": "To continue your request for Roadside Assistance, please contact us at",
  "6319846836201438088": "We'll send battery service instead of a tow",
  "2116258634049106009": "A technician will test your battery and charging system.\n\nIf your battery qualifies for replacement and service is available, a new battery may be installed on-site.\n\nAdditional service options may be required based on the technician's evaluation.",
  "1220581101415477786": "A technician will evaluate your battery and attempt to get your vehicle running.\n\nIf the vehicle cannot be jump-started, additional service options may be required.",
  "8720977247725652816": "Ok",
  "4817224180479830366": "Battery replacement available from {$PH} to {$PH_1}",
  "8030469785630718891": "What's happening with your vehicle?",
  "8021063924309651332": "Tell us more about the problem",
  "7919802320394920933": "LET'S FIGURE THIS OUT",
  "6294584129851319066": "So we send the right truck the first time.",
  "6033469492202356107": "{$PH}, selected",
  "6961397537815994802": "Location name",
  "8118425118386970064": "user gps location",
  "5019415900627253696": "user location pin",
  "520216862429232810": "locate user off",
  "7759322752374112937": "We do not have permission to use your location.",
  "4302275947494969248": "locate user",
  "5914197729137852352": "zoom in",
  "2712619242453112454": "zoom out",
  "4949889994019151135": "Adjust Location",
  "749435979294434408": "Search this area",
  "8868423544621246196": "Adjust Pin",
  "7469788397782054772": "Use Current Location",
  "3253942101340114349": "Unlock Member Benefits and Save",
  "1851052365566269794": "Up to $75 Off Labor at AAA Approved Facilities.",
  "7661734687633394672": " We could not load the map. ",
  "2372962615374041806": "retry loading the map",
  "5558369032942896106": "Tap to retry",
  "5784148293777218417": "Loading map...",
  "4336812953219770811": " Tow To This Location ",
  "9051743466865402679": "AAA logo",
  "2315124459340038479": "Up To $75 Off Labor",
  "187187500641108332": "{$INTERPOLATION}",
  "6126653859421382230": "Additional Savings",
  "5088227879097923599": "or Info Provided",
  "7426652496974317087": "AAA Owned",
  "3507975269329421784": "AAA Approved",
  "6481304460259131456": "DC Fast",
  "1133429843474832091": "40 miles of range for every 10 minutes of charging.",
  "9137973907103012820": "AC Level 2",
  "2033980371929070403": "Typically around 26 miles of range per hour of charging.",
  "7222466127893410268": "AC Level 1",
  "7398398441416372596": "4.5 miles of range per hour of charging, or about 22 hours for a full charge.",
  "8780046504816913168": "Station charging level",
  "1184558138767114183": "EVSE Ports",
  "3502982390707577330": "Ultra-Fast",
  "4440784179849538382": "Fast",
  "5982496808088686844": "Medium",
  "6080928629553303128": "Slow",
  "5185828311001602866": "Chargers",
  "5807244259479135620": "Station Notes",
  "1827769659765031479": " Last updated on {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG}.\n",
  "4738544208382295311": " *EVSE Ports details and availability are subject to change.\n",
  "2419459929780942088": "Let’s Find You and Your Vehicle",
  "4540513583141016694": "Please, click Allow when the browser prompts for your current location.",
  "4107594969119943724": "Service Location",
  "3630564783213610949": "It's the fast way to access your precise location.",
  "5283964866465243726": "Please use your home address or enter your breakdown location.",
  "2668733150597455494": "Please enter your breakdown location.",
  "7501294018510225443": "Find My Location",
  "3330279138270994973": "Use My Home Address",
  "6157723643771310203": "{$PH} between exits {$PH_1} and {$PH_2}",
  "3981024025956691731": "{$PH} near exit {$PH_1}",
  "6945807479901116465": "I'm traveling with a service animal",
  "8501473605570816670": "I'm using a wheelchair",
  "7722780722933930930": "I'm visually impaired",
  "3029169435027075291": "I'm hearing impaired",
  "1458126921436666295": "assets/drrweb-lib/images/prompt-ios-service-location.png",
  "4506457520434156753": "assets/drrweb-lib/images/prompt-chrome-windows-service-location.png",
  "8199801917286894103": "assets/drrweb-lib/images/prompt-android-chrome-service-location.png",
  "8054771849619467014": "assets/drrweb-lib/images/prompt-default-service-location.png",
  "1880639245768521590": "assets/drrweb-lib/images/prompt-ios-service-location_rap.png",
  "470179781733224614": "assets/drrweb-lib/images/prompt-chrome-windows-service-location_rap.png",
  "5417158386549523985": "assets/drrweb-lib/images/prompt-android-chrome-service-location_rap.png",
  "734691974514323473": "breakdown location pin",
  "2998515033796523032": "tow location pin",
  "1685394033947973419": "car location pin",
  "783289646359960934": "AAA owned facility pin",
  "1508301018702466424": "AAA approved facility pin",
  "4185783213014835176": "EV Station pin",
  "5008865478775109392": "custom destination pin",
  "2327312841241610698": "How many people need a ride in the tow truck?",
  "7127748442885437513": "Safety is our top priority. Our service vehicles can only accommodate up to 2 riders.",
  "8966552286310112745": "Zero",
  "6983516129072435613": "One",
  "3594109821899435342": "Two",
  "579574604287234278": "Three or More",
  "3767698756435505409": " Select Facility ",
  "8293925737093594699": "Immediately Available",
  "5385748884885581412": "Available Now",
  "2152960452087805667": "Filter:",
  "2893872988800957667": "Show open facilities",
  "7593555694782789615": "Open",
  "4825929943644490784": "Show all facilities",
  "1616102757855967475": "All",
  "1218302359178184742": "Sort by:",
  "3834095095299577159": "Distance filter",
  "1318378369686604409": "Sort distance",
  "1779552786277618671": "Distance",
  "4229248268019362542": "Rating filter",
  "872726928974144719": "Sort rating",
  "3706222784708785028": "Rating",
  "2476371896418380506": "There are no available facilities in your area. Please enter a custom address where you would like your vehicle towed.",
  "6962699013778688473": "Continue",
  "3350597898571280062": "* approximately {$PH} miles beyond your plan's limit",
  "3147697078524954695": "The tow location you have selected is more than {$PH} miles away. Please verify your towing destination. If the address is accurate and you'd like to proceed with this destination, please give us a call.",
  "7117678034952001806": "The tow location you have entered is greater than {$PH} miles away. Do you wish to proceed?",
  "1654520694751781139": "We received your payment, but your membership activation is taking longer than expected.",
  "1341731694437214881": "For additional assistance, please call AAA",
  "6818973470543082695": "We'll also keep checking automatically while this screen is open.",
  "8970683817306462247": "We're activating your membership",
  "9008789757598843790": "Still activating…",
  "4075464256749670957": "Your payment was received successfully. Membership activation takes a few minutes.",
  "5127370872020214133": "Your payment has been received. We're still working on activating your membership.",
  "8451263051582719390": " Your AAA membership expired ",
  "8145511312111660177": " Renew now to request roadside assistance. ",
  "5237646879301056056": "Coverage available within minutes",
  "2890192322152476399": "Covers you in any car (not just yours)",
  "5090376090543506834": "24/7 nationwide roadside support",
  "7106302757096019164": "renew and get help now",
  "3164637444548569676": "Renew & Get Help Now",
  "5793787693521708768": "Secure. Private. Always protected.",
  "426701527291002798": "Cancel Request",
  "5202442660425731545": "Reserved for extra peace of mind",
  "1640609344969975994": "To",
  "65596648518773631": "Request Status",
  "7562455884504549375": "Your Request Summary",
  "8536605442386598925": "*ETA is only an estimate. A real time ETA will be provided once your service provider is in route.",
  "1586840493150773164": "Passkey created successfully!",
  "2241797766725932109": "Passkey couldn't be created.",
  "6695885093928433058": "Appointment Scheduled",
  "3670741770315416004": "Request in Progress",
  "471816275243265264": "Location",
  "7132893068309658147": "Vehicle",
  "5833626790712999947": "Issue",
  "2786645340010357367": "Tow To",
  "8725876728905260297": "Special Assistance",
  "1965356297860228129": "Passengers",
  "2296656948615950410": "Click to indicate if you are traveling with a service animal, are using a wheelchair, are visually or hearing impaired.",
  "1220184337562705199": "Review and Submit",
  "2390801852034799296": "You're almost there.",
  "7768495123558312657": "Additional Details",
  "4691558063344690327": "* Who will be waiting with the vehicle?",
  "4841246928267486909": "First Name is required.",
  "1761459821395698863": "Last Name is required.",
  "2307899152676024835": "Last Name must be at least 2 characters.",
  "5980374903542048136": "* How can the driver reach you?",
  "8194554728555410336": "Phone Number",
  "7242666881048019433": " Phone Number is required. ",
  "7528160882558679290": " 10-digit Phone Number is required. ",
  "4186571613071118113": "Text me updates",
  "1807135899468939070": "Messages and data rates apply. You may also receive follow-up surveys via text.",
  "407167630580620391": "Schedule Options",
  "5471200873438312944": "Request Details",
  "2907103121504575461": "To receive service:",
  "4158861237816179273": "Be with the vehicle when help arrives.",
  "5885392364610839626": "Show your driver license and membership card.",
  "7351828748339218663": "The vehicle must be registered.",
  "5203410453077950595": "If these conditions are not met, service may not be provided.",
  "6674369792289154406": "To receive service, please ensure:",
  "4708208019684315889": "You are with the vehicle when help arrives",
  "2577934289378208964": "You show your driver license",
  "8368187995205437382": "The vehicle has a valid registration",
  "4364826466877448830": "Submit Request",
  "3502515833012687476": " Your request is taking a little longer than expected! Thank you for your patience. ",
  "4070301057313245497": "Previous tow destination",
  "7877546010612799744": "Next tow destination",
  "7011552147496839463": "Hide Cards",
  "7707573867079284235": "Show Cards",
  "7353391633559525757": "View List",
  "7668320482416064562": "Loading facilities",
  "5028777105388019087": "Details",
  "3762979430784316447": "Tow to Facility",
  "5621871733375268792": "Finding Nearby Facilities…",
  "4394425444565366157": "This may take a few seconds",
  "5212875263922018260": " Please select a tow destination ",
  "5117814417431538560": "Available Facilities",
  "1778689203508413470": "View On Map",
  "1581537317993347062": "No Nearby Facilities",
  "6637503874356397315": "Enter Custom Location",
  "3165693768265430259": "Tow Location",
  "6171321268156747297": "Truck capacity limited",
  "4732097627397727883": "Trucks only have 2 seats available. In order to safely transport all of your passengers, please find other means of transportation.",
  "3042471551767868839": "Notice",
  "1149926629858366555": " Your request cannot be created/cancelled at this time, for assistance please contact us at ",
  "714734299696371803": "dismiss this message",
  "4128937884409277931": " Dismiss ",
  "8525213662266893834": "Contact us",
  "202442244688100878": "close",
  "5547981558491672240": " Close ",
  "1843612596643057114": " Coverage Exhausted ",
  "89956979946656905": " Your coverage is exhausted. To explore your options, please call: ",
  "5342146806420323673": "An error has occurred at this time.",
  "3619829665188684364": "For additional assistance, please contact us at",
  "573014776611181853": "Unable to Authorize",
  "4851841151431186708": " We are having trouble authorizing your membership for road service, please try again. If the problem persists, please contact us: ",
  "6997455656073982155": " To continue your request for Roadside Assistance, please contact us at ",
  "3460597674362212012": " We're Sorry! ",
  "3597534558032156787": " We are having trouble verifying your membership, please try again. If the problem persists please contact us: ",
  "2674407765127209694": " We are having trouble verifying your reference number, please try again. If the problem persists please contact us: ",
  "1967275184995311651": "We're Sorry",
  "5047942184110371848": " Your device's operating system doesn't support this feature. To continue, update your operating system to the latest version or contact us for assistance: ",
  "3145106811611964936": " We are having trouble verifying your subscriber number, please try again. If the problem persists please contact us: ",
  "2746225969289306647": "Your request cannot be made at this time.",
  "3964046316066867815": "Update My Location",
  "3971100408152984961": " Next ",
  "4697489577451788862": "Call Cancelled ",
  "3049349201532302920": " Your call was cancelled. If you need additional assistance, please call: ",
  "3445785675238664638": "Call Completed ",
  "4394774848447555911": " Your call was completed. If you need additional assistance, please call: ",
  "8145625183898098569": "Ongoing Request",
  "7179250617627296125": "We are unable to complete this request because you may already have an active service request,",
  "7563348316522405611": "please call AAA for assistance.",
  "624925154094700659": "please call us for assistance:",
  "6875129378498130947": "Load Request",
  "6061761806308938004": " Load Request ",
  "4228815428302028705": "Your Member ID",
  "8787812510068520833": " We are sorry to hear you do not have your AAA Membership number. As a reminder, your member number can be located on the front of your AAA Membership Card. ",
  "5796746532161831712": "To continue your request for service, please call the number below.",
  "2159130950882492111": "Cancel",
  "9178182467454450952": "Confirm",
  "7875361674553895704": "restart",
  "7970662669745283158": "{$PH} Roadside Request?",
  "2569337048425166220": "Don't worry, any information you've entered will be saved.",
  "3559861716234464695": "If you restart any information you've entered will be lost.",
  "5556232190900941384": "You are on the {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG}, which can only be serviced by authorized providers.",
  "4883556295987649416": "Please click below to call the {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG} for emergency road service.",
  "4000395523613920402": " Update My Location ",
  "5134046032924026802": " The location you selected is more than {$INTERPOLATION} miles from your GPS coordinates, {$START_BOLD_TEXT}is this correct?{$CLOSE_BOLD_TEXT}",
  "3603720768157919481": " No ",
  "6599544439234082262": " Yes, Continue ",
  "3624087939467349290": "Advisories",
  "1373283122802403731": "Not available in your area",
  "1428411674072210734": "Roadside assistance is currently not available in your area at this time.",
  "6096210050791665674": "Not a Member?",
  "2338939239122506630": "We can still help.",
  "1946294985129328189": " Give us a call, and we’ll connect you to a customer service representative. ",
  "6485080467526385593": "If you have been in an accident please follow state laws ",
  "394133167965760742": "and guidelines for requesting emergency assistance.",
  "5178599162303761880": " CALL 9-1-1 ",
  "5651212469606235921": "Roadside Request Cancelled",
  "5630357643750336045": " We're sorry if you're having trouble. If you need additional assistance, please call: ",
  "927769103476181261": "{$INTERPOLATION} Please contact us so that we may assist you.",
  "8768553494169426221": "Your tow to destination appears to be the same as your breakdown location. Please update the tow to destination to proceed.",
  "6759205696902713848": "Warning",
  "3211375812239059616": "Your session is about to time out!",
  "1594967442652354065": "Press the button below \"Continue Session\" to remain logged in.",
  "6529234709124727228": "Continue Session",
  "4914709593048205667": " Continue Session ",
  "4216697563325477660": " * approximately {$INTERPOLATION} miles beyond your plan's limit ",
  "8309867053765019374": "The destination address is incomplete. Please select a destination containing at least a street name.",
  "1812273367521629087": "Additional info required",
  "2995600988434044148": " First Name is required ",
  "2330577642930707695": " Cancel ",
  "2234340424130179004": "Street Number ",
  "4909632409145902244": " Street number is required ",
  "5695082808871799804": "Help us Find Your Account",
  "2098506548009623840": "Please enter the phone number associated with your AAA membership:",
  "2097047258816797651": "HINT:",
  "3965497959922603703": "Phone Number of primary account holder",
  "4328252963732594198": " Phone number is required. ",
  "7608815404856420812": " Phone number must be exactly 10 digits. ",
  "5207905874002096604": "The phone number entered does not match any of the above.",
  "7834793667311493084": "3-Year Free Replacement Limited Warranty",
  "7383286124047740036": " Engine: ",
  "5580626612188557413": " Part #: ",
  "2925999321421245631": " CCA: ",
  "1740519976235479440": "Member Price:",
  "5882908235465956540": " Your Member Savings: ",
  "487840642825782696": " *Price does not include sales/EPA taxes and possible labor charges. Inventory availability varies, if your battery is unavailable a battery test and jump start or tow will be provided. ",
  "1660435965636215711": "Why Are You Canceling?",
  "4998851725171607335": " Please help us understand why you'd like to cancel your roadside request: ",
  "8693603235657020323": "Other",
  "5278917978974156212": "Tell us why you're canceling ...",
  "554566638268240771": " Please, add a feedback comment. ",
  "8191160628682052797": "Please request roadside assistance when you are ready.",
  "2433918188239435254": "Thank you for notifying us that you’ve requested service from another service provider.",
  "6634932823875452919": "Thank you for notifying us that your vehicle started and that you no longer require roadside assistance.",
  "5042135316044918443": "An active AAA Membership to receive roadside service.",
  "9130943841771661280": "A valid photo ID at the time of service.",
  "2795185191739439901": "Members be with the vehicle at the time of service.",
  "6101771822405833037": "We are currently servicing AAA members around your area.",
  "4800017478718258125": "Thank you for notifying us that a friend or family member has assisted you and that you no longer require AAA assistance.",
  "3978003244051742456": "Thank you for notifying us of the incorrect breakdown or tow location. Please update the address and resubmit your request if you still need assistance.",
  "725801066718064552": "Please contact AAA if you need further assistance.",
  "8336086995176361561": "My Vehicle Started",
  "8301498400691107352": "Not with my Vehicle or No Photo ID",
  "4921174424767158794": "Long ETA/Wait Time",
  "3790229158895884861": "Friend or Family Member Assisted Me",
  "70601770189571078": "Requested Service with Another Provider",
  "4542685776525522536": "Wrong Address for Breakdown or Tow Location",
  "1228041941681869539": "I Will Submit My Request Later",
  "5570922785143068862": "We Will Be Here When You Need Us",
  "4547976577033030523": "Thank You for Keeping Us Informed",
  "1273563518651033849": "You’re Back on the Road",
  "3605654267658930496": "AAA Roadside Service Requires",
  "6631370214417821009": "We Apologize for the Long Wait",
  "1463264795502028813": "Thank you for Keeping us Informed",
  "2574924088459765443": "Incorrect Location Provided",
  "6514305188130738666": "Thank You for Your Feedback.",
  "3170892836969933563": "Facilities Preferences",
  "199681881373518804": "Member Benefits",
  "4636616640072565270": "Saving",
  "8257281017979049775": " Up to {$START_TAG_AAA_TEXT}{$INTERPOLATION}{$CLOSE_TAG_AAA_TEXT} Labor at AAA Approved Facilities. ",
  "8461842260159597706": "Show",
  "4461870650853986011": "Open Now",
  "7705146805699679308": "Toggle Open Now",
  "3163736126501632521": "Ready to accept your vehicle",
  "5992079258862809181": "Toggle Available Now",
  "7699622144571229146": "Sort by",
  "6184900616909551342": "Member Rating",
  "4312517319627808728": "Reset Filters",
  "6978234364807213493": " Reset Filters ",
  "4252274043276232149": "Apply Filters",
  "3764298087243734987": " Apply Filters ",
  "8221191823278537940": "$75 Off",
  "3335125097066671488": "Choose your new language:",
  "4640251381797093653": "Units System:",
  "1082186572052604070": " Help us find you! ",
  "920498844333598862": "Provide us with additional info to help the driver reach you.",
  "1793340305918324038": "Nearby building or street: ",
  "4317231584543100875": " Please, add a comment to help us find you. ",
  "6433934975299076647": " Creating a Passkey ",
  "7960261666827623084": " If you're having trouble creating a passkey, try the following: ",
  "3226515165280717048": "Tips for creating a passkey",
  "4585655302901132242": " Make sure your device and browser support passkeys. ",
  "8204277307134103557": " Turn on your device's screen lock (Face ID, Touch ID, fingerprint, or PIN). ",
  "1742310145780775447": " Update your browser and operating system. ",
  "2530911237912691285": " If you're using a private/incognito window, try a regular browser window. ",
  "2480700450286234631": " Follow the prompts to create and save your passkey. ",
  "5151302772594817091": " If the option still doesn't appear, try another browser or device. ",
  "343835394852176599": "Creating a Passkey",
  "1239986160529764202": "Create a Passkey",
  "6233136260309825485": " Create a Passkey ",
  "6232880258565681833": " While you wait, you can set up a passkey for quicker, password-free sign-ins next time. ",
  "3629102297901837941": "Available sign-in methods",
  "1528205876811012885": "Face ID",
  "6944174136827022440": "Touch ID",
  "1644631291332591230": "Passcode",
  "2585004117222105295": " Create Passkey ",
  "8381471742922310449": " Not now ",
  "2094590441447362024": "About Passkeys",
  "5288176706687121532": "Problems creating a Passkey?",
  "7836958718246237142": " Sign in with Passkey ",
  "1786179172967092395": "{$START_TAG_SPAN}Passkeys{$CLOSE_TAG_SPAN} are designed to replace your traditional passwords and can be used to access AAA Digital Roadside Assistance. It is an optional authentication that offers a safe, secure login experience using end-to-end encryption. ",
  "1895659320322539850": "Passkey benefits",
  "6125393979162068859": " Faster, password-free sign-in ",
  "6921393565505052089": " Enhanced security with device authentication ",
  "2286904483650741837": " Syncs across your trusted devices ",
  "3700327405617139488": " Setting up a Passkey ",
  "2408837570872877476": " Sign in using your first and last name or your AAA membership number. ",
  "6826884095497629723": " Complete your Roadside service request. ",
  "2815732092125234624": " If your device supports Passkeys, you'll be prompted to create one after you submit your digital roadside request. ",
  "4134229199185847776": " Follow the on-screen instructions to complete setup. ",
  "3977779423491488098": " The next time you log into AAA Digital Roadside Assistance, you'll be all set to sign in securely without a password. ",
  "5853440980923544185": " Having problems signing in or creating a Passkey? ",
  "7096986431591826685": "Sign in with Passkey",
  "7915635145286683183": "Using Passkey to sign in",
  "3569641787255523569": " Using Passkey to Sign in ",
  "7061285914825382189": " If you're having trouble using a passkey, try the following: ",
  "1619866045452626924": "Tips for using a passkey to sign in",
  "6104344328428105328": " Use the same device where your passkey was created. ",
  "1839199488887182672": " If you're using a different device, sign in using another available method. ",
  "6841371375885083076": " Make sure your device's biometric authentication (Face ID, Touch ID, fingerprint, or PIN) is enabled and working properly. ",
  "2234009211835487407": " Lost Access to Your Device? ",
  "2939285354959258686": " If you no longer have access to the device where your passkey was created, sign in using another available method and create a new passkey on your current device after you submit your digital roadside request. ",
  "1475642740902337582": "See reviews",
  "8895523169171160716": "Select this facility",
  "9162819567693962814": " Please contact us at {$START_LINK}{$INTERPOLATION}{$CLOSE_LINK} so that we may assist you.",
  "1096523922580861220": "AAA Members discount awards",
  "129773953916702393": "This Facility Offers AAA Members:",
  "6497936021121348661": "AAA Members receive a 10% labor discount on repairs performed at this facility. The maximum labor discount is $75.",
  "8686926613390516729": "Toggle facility comments",
  "7215101881367554791": "Show more",
  "3517550046701184661": "Show less",
  "2096293725142689481": "Repair Services",
  "8070396816726827304": "Hours",
  "1637807395996624480": " The AAA member is required to be with the vehicle when assistance arrives. ",
  "6232767962101986120": "Please be prepared to show Photo ID.",
  "6108303594027259064": "Think you may need a new battery ?",
  "8407027090855094486": "As AAA member you {$START_BOLD_TEXT}SAVE{$CLOSE_BOLD_TEXT} on all battery purchases!",
  "4822875174643597985": " *Battery replacement may not be available in all areas or at all times. ",
  "4550483070637072617": " GET AAA BATTERY QUOTE ",
  "1081985883670154175": " Unfortunately, we couldn't find any battery quotes for your vehicle. ",
  "7532012621192092169": " CLOSE ",
  "6628195999288023750": "Select any options that apply so that we can provide the best assistance.",
  "2422796432434276307": "Service animal",
  "8502519270764282647": "Traveling with service animal",
  "5365957413422942691": "Wheelchair",
  "3367838042296862793": "Using mobility device",
  "3095443157864275679": "Visual impairment",
  "9183526258645897709": "Low vision or blind",
  "1184769887075133184": "Hearing impairment",
  "8853351689294432570": "Hard of hearing or deaf",
  "398580216793616453": "Invalid Membership Number. Please try again.",
  "2246225278009002637": " Creating a Passkey... ",
  "3714782270026873188": " Verifying With Passkey ",
  "8973767917273413404": " Authenticating with Passkey ",
  "1927565598938891479": "Mileage (In Kilometers)",
  "6910896812795408604": "Mileage (In Miles)",
  "2339499141149709632": "Add Vehicle",
  "7893027042015332014": " What is your vehicle's license plate? ",
  "1314196602451866850": "no vehicles found",
  "2394888073923801575": "No vehicles found",
  "2467416691089785042": "The License Plate or State you entered is not correct. Please try again or add your vehicle using Make/Model.",
  "810339320514898406": " Add Vehicle ",
  "2375804625902745188": " Add Vehicle By Make/Model ",
  "2374658616297168667": " I Don't Know My License Plate ",
  "4525869092770982814": "Add Vehicle By License Plate",
  "1645353594399026859": "Add Vehicle By Make/Model",
  "8080814233715803011": "Vehicle Color",
  "388441439738092480": "Select your vehicle's color",
  "8778069024168313408": " Select your vehicle's color ",
  "3881818169480672345": "other",
  "7585826646011739428": "Edit",
  "5038022816605629090": "Vehicle Make",
  "5530596553958425101": "Select your vehicle's model",
  "5930101473609793295": "Select your vehicle's make",
  "8573148273930915356": "Popular Makes",
  "1711723330428686508": "Vehicle Model",
  "4877541786961592871": " Select your vehicle's model ",
  "8737634160504397001": "I have a 4WD or AWD Vehicle:",
  "1143180333250868580": "I have a dual rear wheel vehicle (4 tires in the back):",
  "7312227291647643129": "Please, select a model.",
  "3472776637183381934": "This is required. Please select either Yes or No.",
  "4783450617882080730": "Type your vehicle's model",
  "6820908718479259935": "Vehicle Selection",
  "6531169844162626489": "Which vehicle needs service?",
  "729718385405804359": " Add a vehicle by clicking the button below ",
  "4366195030139372163": "Add a vehicle",
  "3643061693604299445": " Neutral ",
  "3309177967835549878": " Color ",
  "2376622895856215212": "Other Color",
  "2277948714128983283": " Please select your vehicle: ",
  "3735258877351129283": " My Vehicle Is Not Listed Above ",
  "3104908833501051654": "Vehicle Details",
  "322698561656118648": " VEHICLE INFORMATION ",
  "4663044829079526277": " Confirm Vehicle ",
  "245000125673083892": " This is Not My Vehicle ",
  "1464072562214937907": "Year",
  "1511766279515968094": "Make",
  "1141886420788473147": "Model",
  "9011959596901584887": "Color",
  "1600602015083950162": "Select vehicle make",
  "8419013471383350703": "Select Vehicle",
  "8230776842044911093": "Deleting Vehicle",
  "7469554111775846390": "Please confirm deletion of the vehicle:",
  "7022070615528435141": "Delete",
  "1369053091611033364": "Vehicle year",
  "2501218570987929523": "Vehicle Year",
  "4474074263097209509": " Select your vehicle's year ",
  "4055565142797463521": "silver",
  "5358044029583463092": "white",
  "2390091576468691188": "black",
  "903698715562631272": "blue",
  "4750497417886366863": "red",
  "3052455234498663450": "maroon",
  "6489918809066415959": "gray",
  "3561083222684861262": "purple",
  "1593879950157831165": "brown",
  "463342854199748936": "gold",
  "6192244276175907743": "green",
  "1850999561099918087": "yellow",
  "4955630191692571673": "orange",
  "4931988436168518415": "Request Assistance Now",
  "4815628358304255769": "We're sorry, no time slots available.",
  "7283311229665311962": "Please try another date.",
  "4818764971362919096": "Choose a Time",
  "7017917500632081165": "Services can be requested up to three days ahead, and service windows are two-hour time slots.",
  "7162759804277992326": "Request a service and go",
  "4244383936205942663": "Schedule Assistance For Later",
  "3293376965478600452": "Reserve for extra peace of mind",
  "3933901227138831501": "Change Schedule",
  "3207050836358092212": "to",
  "6048892649018070225": "Today",
  "9129734193759025482": "Tomorrow",
  "790046669946855510": "License Plate",
  "7147656645758186590": "License plate is required.",
  "3846775516007566225": " Mileage is required. ",
  "7671097566105516848": " Mileage number is too long. ",
  "8540477892957058580": " Mileage cannot be lower than {$INTERPOLATION}. ",
  "5712324546519089702": "Home Postal Code",
  "2240639906372943686": " Postal Code is invalid. ",
  "1999486591901322407": " Postal Code is required. ",
  "2482107679054510701": "Select State",
  "5911214550882917183": "State",
  "247788107015006101": "State is required.",
  "6883930691020393717": "Opens",
  "5961730753997685905": "Closes",
  "4585513060399239894": "United States (English)",
  "4677726785527621059": "EN",
  "3863208364160367374": "Canada (English)",
  "5203393227857890726": "Canada (Français)",
  "2219810385897343218": "FR",
  "2388828436796635945": "miles",
  "5380734885525984829": "mi",
  "4008226394730667091": "kilometers",
  "6044256456943348938": "km",
  "7837264740889869517": "AAA",
  "6449433906928390518": "Flat tire",
  "7768588440687754652": "Multiple Flat Tires",
  "3260747694170614659": "Bicycle Assist Service",
  "4949163154570277605": "Other Tire Problem",
  "3937483171289747438": "Engine Overheat",
  "1182848575500495908": "Car won't start / Battery issue",
  "4393476988942899254": "Battery Test or Replace",
  "806714067987240899": "No Crank - Bat Svc (AAA Bat)",
  "887388902744869206": "Member Requests Battery Service",
  "5915528902414335352": "Need a tow",
  "1783762556138691700": "Known Starter Problem",
  "3152273838150533542": "Known Alternator Problem",
  "8729670228441145182": "Other No Crank Problem",
  "5320409527192031890": "Car won't start",
  "1121003247955159358": "Out of fuel",
  "5106773987744819236": "Electric Vehicle (EV) Out of Charge",
  "89567510748154107": "Vehicle Mis-Fueled",
  "7608866105677900135": "Out of charge",
  "7718232202645290143": "Other Crank No Start Problem",
  "1607751549135472283": "Won’t Go Into Gear",
  "2635833232154216737": "Parking Brake Won’t Release",
  "4902704560614484469": "Hood/Door Won’t Close/Latch",
  "8651276109470896460": "Undercar Component Dragging",
  "3627302731165021591": "Leaking Fluids",
  "2411256270426279168": "Windshield Damage",
  "4352351100111809871": "Car Alarm Issue",
  "1764347429718613820": "Transmission/Clutch Failure",
  "300454884679414178": "Axle/Driveshaft/Suspension Failure",
  "3275110414994727760": "Brake System Failure",
  "8307876019330383117": "Other Runs Won’t Move Problem",
  "1422534409101194863": "Engine Stalled While Driving (or Engine Runs Poorly)",
  "6346197418191521032": "Engine Stalled While Driving (or Other Runs Poorly Problem)",
  "6199390654915059120": "Key Locked In Trunk w/Trunk Release",
  "1134916509776830024": "Key Broken In Door - Not Ignition Key",
  "4816129840545463770": "Frozen Door Lock",
  "5269606850167934629": "Other Lockout Problem",
  "701251608477934057": "Key Locked In Trunk-No Trunk Release",
  "6142348476301771589": "Lost/Damaged Vehicle Key",
  "284656505395688931": "Lost/Damaged “Club” Key",
  "3514211625272598553": "Key Broken In Door - Ignition Key",
  "418615325007080430": "Key Broken In Ignition Switch",
  "8129095023010033917": "Home Lockout",
  "1908434710229907061": "Vehicle Fire",
  "7996328812789188583": "Convenience/Member Concern Tow",
  "7466069527670677597": "Insurance Accident Assist",
  "1498787579904490729": "Insurance Accident Assist - Second Tow",
  "621862718126105807": "Light Service Redispatch As Tow",
  "4351481082957031931": "Other Required Tow",
  "9196553889100032955": "Locked out",
  "6085791871913838678": "Battery Issue",
  "3322791211742541863": "No Crank - Bat Svc",
  "1590050062584587387": "Battery Service",
  "1245793507890087845": "Convenience Concern Tow",
  "8890553633144307762": "Back",
  "8074044239461230413": " Welcome, {$INTERPOLATION}! ",
  "2171108128625220759": "Membership type: ",
  "5162055214272417357": "Call ID",
  "939198311791613190": "Switch Language",
  "4211737493693856650": "Have an Emergency?",
  "9009534756135128779": "Powered by RESPONSE",
  "2675561881742221955": "Use Vehicle Identification Number (VIN)",
  "3724691018613206036": "Use Vehicle License Plate",
  "3554560152057051008": "We're personalizing your experience…",
  "5239049161374840743": "This is taking a bit longer than expected.",
  "6656565264392926597": "Thanks for your patience.",
  "3119946717514237807": "Your Service Tracker is open.",
  "1293315060547166486": "Swipe up on the tracker window or tap below to continue tracking your technician.",
  "8896053661242873097": "Continue Tracking",
  "9047657667885056779": "It seems the tracker was closed.",
  "2861641926550874295": "Tap the button below to view your Service Tracker.",
  "5587865907622609469": "View Service Tracker",
  "3367606868529944362": "Call Shop",
  "994157966875519838": "review",
  "6306441078838263413": "reviews",
  "5697775455373856404": "https://www.aaa.com/privacy",
  "5681080907064940207": "Privacy policy content",
  "325297667007265879": "https://www.aaa.com/AAA/common/drrsmsterms/terms.html",
  "9136883653011874874": "Terms and conditions content",
  "3907277565443688400": "It seems we found a problem.",
  "2898103473773345400": "Sorry, we can't display our Service Tracker on this page.",
  "3827211250193888984": "Go To Service Tracker",
  "196852750330820489": "Thank you for being a valued AAA member for",
  "6479044529603381727": "year",
  "7658073495909471632": "years",
  "249946661530734742": "Thank you for being a valued AAA member!",
  "5221447871170578113": "It seems that the dealership selected as your tow destination exceeds typical tow limitations.",
  "5407935879683390459": "It seems that you selected a tow destination that exceeds typical tow limitations, but another dealership is nearby to assist. Please choose from the list of dealerships provided so that we can quickly assist you.",
  "5830141447760502883": "It seems that the EV charging location selected as your tow destination exceeds typical tow limitations.",
  "7488235253439066670": "It seems that you selected a tow destination that exceeds typical tow limitations, but another EV charging location is nearby to charge your vehicle. Please choose from the list of EV charging locations provided so that we can quickly assist you.",
  "7372157508120043424": "Due to high service volume, tow distances are currently limited in your area. Please contact us so that we may assist you.",
  "8313172200055338045": "We're sorry, currently we're not able to tow to this location. Please call for assistance.",
  "8069219870516771588": "RESPONSE Road Service",
  "467028499850443965": "AAA Roadside Assistance",
  "3936734437579216958": " Change vehicle selection ",
  "1894851373519807395": " VIN is required. ",
  "5711449076030373396": "VIN is invalid.",
  "4831448418319098988": "VIN must be exactly 17 characters long.",
  "81381789816265977": "Please call AAA for additional assistance:",
  "5507648102804470429": "Please try again or contact support for assistance:",
  "6431558244296134403": "An error occurred while trying to retrieve your information.",
  "2260468369477279302": "An error occurred while trying to retrieve your member information.",
  "8244890085971995980": "An error occurred while trying to remove this vehicle."
}